import React from 'react'
import { ExtractItem } from 'src/utils/extractDescription'
import { Internal } from '../proofs/Internal'
import { InternalTax } from '../proofs/InternalTax'
import { P2P } from '../proofs/P2P'
import { PagbankPayment } from '../proofs/PagbankPayment'
import { PagbankPaymentDiscount } from '../proofs/PagbankPaymentDiscount'
import { Payment } from '../proofs/Payment'
import { Pix } from '../proofs/Pix'
import { PixKey } from '../proofs/PixKey'
import { Slip } from '../proofs/Slip'
import { Ted } from '../proofs/Ted'
import { TransferWithPix } from '../proofs/TransferWithPix'
import { Modal } from './styles'

interface props {
  modalIsOpen: boolean
  data?: ExtractItem
  user?: any
  afterOpenModal: () => void
  closeModal: () => void
}
const ModalConfirmOperation: React.FC<props> = ({
  afterOpenModal,
  user,
  closeModal,
  modalIsOpen,
  data,
}) => {
  if (!data) return <></>

  const txType = data.type.toLowerCase()
  const Proof =
    txType === 'pix_key' || txType.includes('tax') ? (
      <PixKey data={data} closeModal={closeModal} />
    ) : txType === 'transfer_with_pix' ? (
      <TransferWithPix data={data} closeModal={closeModal} />
    ) : txType.includes('pix') ? (
      <Pix data={data} closeModal={closeModal} />
    ) : txType.includes('p2p') ? (
      <P2P data={data} closeModal={closeModal} />
    ) : txType.includes('ted') ? (
      <Ted data={data} closeModal={closeModal} />
    ) : txType.includes('slip') ? (
      <Slip data={data} closeModal={closeModal} />
    ) : txType === 'internal_wallet_transaction' ||
      txType.includes('withdraw') ? (
      <Internal data={data} closeModal={closeModal} />
    ) : txType.includes('internal_tax') ? (
      <InternalTax data={data} closeModal={closeModal} />
    ) : txType === 'pagbank_payment' ? (
      <PagbankPayment data={data} closeModal={closeModal} />
    ) : txType === 'pagbank_payment_discount' ? (
      <PagbankPaymentDiscount data={data} closeModal={closeModal} />
    ) : txType === 'payment' ? (
      <Payment data={data} closeModal={closeModal} />
    ) : (
      <div className="flex flex-col h-full w-full py-20 items-center justify-center">
        <span>Esse extrato ainda não esta pronto...</span>
        <span>Tente novamente mais tarde.</span>
      </div>
    )

  return (
    <Modal
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
    >
      {Proof}
    </Modal>
  )
}

export default ModalConfirmOperation
